import client from './client';
export const reportValidationAPI = {
    async getRecipientStatus(data) {
        const response = await client.get(`/validate/${data.hash}/recipient`, {
            params: { email: data.email, token: data.token },
        });
        return response.data.data;
    },
    async sendCode(data) {
        const response = await client.post(`/validate/${data.hash}/send-code`, {
            email: data.email,
            token: data.token,
        });
        return response.data.data;
    },
    async registerTarget(data) {
        const response = await client.post(`/validate/${data.hash}/register`, {
            email: data.email,
            token: data.token,
        });
        return response.data.data;
    },
    async verifyCode(data) {
        const response = await client.post(`/validate/${data.hash}/verify-code`, {
            email: data.email,
            token: data.token,
            code: data.code,
        });
        return response.data.data;
    },
};
